import { render, staticRenderFns } from "./dashboard-page.vue?vue&type=template&id=19d4e5f6&scoped=true&"
import script from "./dashboard-page.vue?vue&type=script&lang=js&"
export * from "./dashboard-page.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-page.vue?vue&type=style&index=0&lang=css&"
import style1 from "./dashboard-page.vue?vue&type=style&index=1&id=19d4e5f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d4e5f6",
  null
  
)

export default component.exports